// extracted by mini-css-extract-plugin
export default {"UpDownButtons":"UpDownButtons_UpDownButtons__uapQ+","down":"UpDownButtons_down__uRY3W","up":"UpDownButtons_up__pFMLu"};